import { Mail, MessageSquare } from 'lucide-react';

const FooterContactInfo = () => {
  return (
    <div className="col-span-1 md:col-span-2">
      <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6 text-gray-900">
        Contact & Office
      </h4>
      <ul className="space-y-3 sm:space-y-4 text-xs sm:text-sm text-gray-600">
        <li className="flex items-center gap-2.5 sm:gap-3">
          <Mail size={16} /> support@trrip.live
        </li>
        <li className="flex items-center gap-2.5 sm:gap-3">
          <MessageSquare size={16} /> +91 8530295666
        </li>
        <li className="flex flex-col gap-1 mt-3 sm:mt-4">
          <span className="text-gray-900 font-semibold text-xs sm:text-sm">Official Address:</span>
          <span className="leading-relaxed text-xs sm:text-sm max-w-sm text-gray-600">
            Orbitra Technologies, Underground Shop No 3, Gokul Plaza, Gawad Wadi, Veer Sawarkar Marg,
            Virar East - 401305
          </span>
        </li>
      </ul>
    </div>
  );
};

export default FooterContactInfo;
